// extracted by mini-css-extract-plugin
export default {"row":"styles_row__tM62q","maintitle":"styles_maintitle__1Q3Lc","searchCol":"styles_searchCol__cOMRy","flex":"styles_flex__LfRtD","icon":"styles_icon__0EJUq","x":"styles_x__bL-HW"};